import React from 'react';
import { Helmet } from 'react-helmet';
import MicrositePage from 'components/MicrositePage';
import './DoubleDrive.css';

export default function DoubleDrive() {
  const title = 'Double Drive Miami';
  return (
    <>
      <Helmet>
        <title>Double Drive Miami</title>
      </Helmet>
      <MicrositePage
        className="microsite-double-drive"
        url={`${process.env.REACT_APP_MMAM_URI}/double-drive-miami`}
        title={title}
        showTitleHeader={true}
        passToken
      />
    </>
  );
}
